import React, { useEffect } from 'react';
import { head } from 'ramda';
import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';
import MortgageSurveyQuestionPresenter, { validate } from 'presenters/MortgageSurveyQuestionPresenter';
import InputWithSlider from 'sharedComponents/InputWithSlider';
import MortgageSurveyPresenter from 'presenters/MortgageSurveyPresenter';

import useStyles from './useStyles';

const InputQuestion = props => {
  const { question, onChange, surveyValues, onValidate } = props;
  const classes = useStyles();

  const field = head(MortgageSurveyQuestionPresenter.surveyValueFields(question));
  const currentValue = MortgageSurveyPresenter[field](surveyValues);

  useEffect(() => {
    const validations = MortgageSurveyQuestionPresenter.validations(question);
    const { isValid } = validate(validations, currentValue);
    onValidate(isValid);
  }, [currentValue]);

  const options = MortgageSurveyQuestionPresenter.options(question);
  const { min, max, marksDivider } = options;

  const handleValueChange = value => {
    onChange([{ field, value }]);
  };

  return (
    <Box>
      <Typography variant="h1">{MortgageSurveyQuestionPresenter.label(question)}</Typography>
      <Box mt={2} />
      <Typography variant="body1">{MortgageSurveyQuestionPresenter.description(question)}</Typography>
      <Box mt={4} />
      <InputWithSlider
        className={classes.input}
        value={currentValue}
        min={min}
        max={max}
        marksDivider={marksDivider}
        label={MortgageSurveyQuestionPresenter.inputLabel(question)}
        onChange={handleValueChange}
      />
    </Box>
  );
};

InputQuestion.propTypes = {
  question: MortgageSurveyQuestionPresenter.shape().isRequired,
  onChange: PropTypes.func.isRequired,
  surveyValues: MortgageSurveyPresenter.shape().isRequired,
  onValidate: PropTypes.func.isRequired,
};

export default InputQuestion;



// WEBPACK FOOTER //
// ./src/sharedComponents/MortgageSurvey/components/InputQuestion/InputQuestion.js